const cliKey = 'key_cliente'
const INITIAL_STATE = {
	cliente: (localStorage.getItem(cliKey) !== 'undefined') ? JSON.parse(localStorage.getItem(cliKey)) : []
}

const clienteReducer = (state = INITIAL_STATE, action) => {
	switch(action.type){
		case 'SET_CLIENTE':
			localStorage.setItem(cliKey, JSON.stringify(action.payload))
			return {
				...state, 
				cliente: action.payload
			}
		case 'CLIENTE_LOGOUT':
			localStorage.removeItem(cliKey)
			return {
				...state,
				cliente: []
			}
		case 'CLIENTE_ERROR':
			return {...state, cliente: []}
		default:
			return state
	}
}

export default clienteReducer